import {
  GetAllWarehouses,
  GetAllWarehousesPayload,
} from "../../services/warehouses/get-all/types";

interface FetchAllWarehouses {
  type: "FETCH_ALL_WAREHOUSES_SUCCESS";
  payload: GetAllWarehouses[];
}

type Action = FetchAllWarehouses;

export type WarehousesState = {
  warehousesList: GetAllWarehouses[];
};

const initialState: WarehousesState = {
  warehousesList: [],
};

export const WarehousesReducer = (
  state: WarehousesState = initialState,
  action: Action
) => {
  switch (action.type) {
    case "FETCH_ALL_WAREHOUSES_SUCCESS": {
      return {
        warehousesList: action.payload,
      };
    }

    default:
      return state;
  }
};
